import React, { FunctionComponent, ReactElement, useState } from 'react'
import AuthContext from '../contexts/AuthContext'
import cookies from 'js-cookie'
import { TOKEN_COOKIE_NAME } from '../constants/auth'
import { TokenResultView } from '../api'

function getUserFromCookie(): TokenResultView | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const token = cookies.get(TOKEN_COOKIE_NAME)
    const savedUserData = localStorage.getItem('wisory_user_login_data')

    if (!token || !savedUserData) return null
    return JSON.parse(savedUserData)
  } catch {
    return null
  }
}

const AuthProvider: FunctionComponent = ({ children }): ReactElement => {
  const [user, setUser] = useState(getUserFromCookie())

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
